webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(100)

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(29)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stf-select stf-select_sm",
    class: {
      'stf-select_has-value': _vm.value !== null && _vm.value !== undefined ? true : false, 'stf-select_opened': _vm.isOpened, 'stf-select_empty': !_vm.options || !_vm.options.length
    },
    on: {
      "keydown": _vm.keyDown,
      "keypress": _vm.keyPress,
      "click": function($event) {
        $event.stopPropagation();
        _vm.open($event)
      },
      "unblur": _vm.onUnblur
    }
  }, [_c('div', {
    staticClass: "stf-select__container"
  }, [_c('div', {
    staticClass: "stf-select__inner-wrapper"
  }, [_c('div', {
    staticClass: "stf-select__value"
  }, [_vm._t("value")], 2), _vm._v(" "), _c('div', {
    staticClass: "stf-select__placeholder"
  }, [_vm._t("label")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "stf-select__search-input",
    attrs: {
      "tabindex": _vm.isOpened ? -1 : 0
    },
    on: {
      "focus": _vm.onSelectFocus
    }
  }, [_vm._t("search-input")], 2), _vm._v(" "), _c('div', {
    staticClass: "stf-select__options-wraped",
    class: {
      'stf-select_opened': _vm.isOpened, 'stf-select_empty': !_vm.options || !_vm.options.length
    },
    attrs: {
      "select-id": _vm.idSelect
    },
    on: {
      "keydown": _vm.keyDown
    }
  }, [(!_vm.isNeedHideOption) ? _c('div', {
    staticClass: "stf-select__options stf-select-options",
    attrs: {
      "role": "combobox",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    on: {
      "mousewheel": _vm.onMouseWheal,
      "scroll": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "stf-select__options-container"
  }, [_vm._t("default")], 2)]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stf-select-option",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.selectValue,
      "keydown": _vm.keyDown
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StfSelectPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StfSelect_vue__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StfSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StfSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StfSelectOption_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StfSelectOption_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__StfSelectOption_vue__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__StfSelectOption_vue__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StfSelect_vue__; });



var StfSelectPlugin = {
  install: function install(Vue, options) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__StfSelect_vue__["name"], __WEBPACK_IMPORTED_MODULE_0__StfSelect_vue__);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__StfSelectOption_vue__["name"], __WEBPACK_IMPORTED_MODULE_1__StfSelectOption_vue__);
  }
};

window.StfSelectPlugin = StfSelectPlugin;



/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getOffset;
/* harmony export (immutable) */ __webpack_exports__["a"] = findAncestor;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasPositioFixedAncestor;
/* harmony export (immutable) */ __webpack_exports__["b"] = isMob;
/* unused harmony export triggerEvent */
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["c"] = addClass;
/* unused harmony export removeClass */
function getOffset(obj) {
  var rect = void 0;
  var win = void 0;
  var elem = obj;

  if (!elem) {
    return;
  }

  if (!elem.getClientRects().length) {
    return { top: 0, left: 0 };
  }

  rect = elem.getBoundingClientRect();
  win = elem.ownerDocument.defaultView;
  return {
    top: rect.top + win.pageYOffset,
    left: rect.left + win.pageXOffset
  };
}

function findAncestor(el, sel) {
  if (typeof el.closest === 'function') {
    return el.closest(sel) || null;
  }
  while (el) {
    if (el.matches(sel)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

function hasPositioFixedAncestor(el) {
  while (el) {
    if (window.getComputedStyle(el, null).getPropertyValue('position') === 'fixed') {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}

function isMob() {
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    return true;
  } else {
    return false;
  }
}

function triggerEvent(el, eventName, options) {
  var event;
  if (window.CustomEvent) {
    event = new CustomEvent(eventName, options);
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, options);
  }
  el.dispatchEvent(event);
}

function hasClass(el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  }
}

function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else if (!hasClass(el, className)) {
    el.className += ' ' + className;
  }
}

function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else if (hasClass(el, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
    el.className = el.className.replace(reg, ' ');
  }
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var i = matches.length;
    while (--i >= 0 && matches.item(i) !== this) {}
    return i > -1;
  };
}

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventHub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var EventHub = function () {
    function EventHub() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EventHub);

        this.eventsCollection = {};
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EventHub, [{
        key: '$emit',
        value: function $emit(name, event) {
            if (this.eventsCollection[name] && this.eventsCollection[name][0]) {
                var _loop = function _loop(callback) {
                    setTimeout(function () {
                        return callback(event);
                    }, 0);
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.eventsCollection[name]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var callback = _step.value;

                        _loop(callback);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: '$on',
        value: function $on(name, callback) {
            if (typeof callback === 'function') {
                if (!this.eventsCollection[name]) {
                    this.eventsCollection[name] = [];
                }

                if (this.eventsCollection[name].indexOf(this.eventsCollection[name]) === -1) {
                    this.eventsCollection[name].push(callback);
                } else {
                    throw new ArgumentExceptions('Callback can not be used twice');
                }
            } else {
                throw new ArgumentExceptions('Callback can not be ' + (typeof callback === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(callback)) + ' event ' + name);
            }
        }
    }, {
        key: '$off',
        value: function $off(name, callback) {
            if (typeof callback === 'function') {
                if (!this.eventsCollection[name]) {
                    throw new ArgumentExceptions('You don\'t have callback on ' + name + ' event ' + name);
                }

                var index = this.eventsCollection[name].indexOf(callback);
                this.eventsCollection[name].splice(index, 1);
            } else {
                throw new ArgumentExceptions('Callback can not be ' + (typeof callback === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(callback)) + ' event ' + name);
            }
        }
    }]);

    return EventHub;
}();

function ArgumentExceptions(message) {
    this.message = message;
    this.name = "Argument exception";
}

var eventHub = new EventHub();

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_stf_select__ = __webpack_require__(30);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StfSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_0__components_stf_select__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StfSelect", function() { return __WEBPACK_IMPORTED_MODULE_0__components_stf_select__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StfSelectPlugin", function() { return __WEBPACK_IMPORTED_MODULE_0__components_stf_select__["c"]; });


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__even_hub_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_lib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_throttle__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'stf-select',

  created: function created() {
    var _this = this;

    this.idSelect = 's' + (Date.now() * Math.random()).toString().replace('.', '_');

    this._optionSelectedCallback = function (event) {
      if (event.selectId === _this.idSelect) {
        _this._close();
        _this.$emit('input', event.value);
        var searchInpitEl = _this.$el.querySelector('.stf-select__search-input');
        _this._beforeSetValueFocus = true;
        searchInpitEl && searchInpitEl.focus();
        setTimeout(function () {
          return _this._beforeSetValueFocus = false;
        });
      }

      if (event.selectId !== _this.idSelect) {
        _this._close();
      }
    };

    this._onOptionMounted = function (event) {
      if (event.selectId === _this.idSelect) {
        _this.options.push(event.option);
      }
    };

    this._onOptionDestroyed = function (event) {
      if (event.selectId === _this.idSelect) {
        var index = _this.options.indexOf(event.option);

        if (index !== -1) {
          _this.options.splice(index, 1);
        }
      }
    };

    this._onOpenedSelect = function (event) {
      if (event.idSelect !== _this.idSelect) {
        _this._close();
      }
    };

    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$on('stf-select-option.selected', this._optionSelectedCallback);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$on('stf-select-option.mounted', this._onOptionMounted);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$on('stf-select-option.destroyed', this._onOptionDestroyed);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$on('stf-select.opened', this._onOpenedSelect);
  },
  data: function data() {
    return {
      message: 'Hello Vue!',
      isOpened: false,
      idSelect: '',
      isNeedHideOption: false,
      hasAncesroFixed: false,
      options: []
    };
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeChild(this.__selectOptionsWrapEl);
    window.removeEventListener('resize', this._runOnResize);
    window.removeEventListener('scroll', this._runOnScroll, true);
    window.removeEventListener('click', this._runOnWindowClick);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$off('stf-select-option.selected', this._optionSelectedCallback);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$off('stf-select-option.mounted', this._onOptionMounted);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$off('stf-select-option.destroyed', this._onOptionDestroyed);
    __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$off('stf-select.opened', this._onOpenedSelect);

    if (this._optionsMutationObserver) {
      this._optionsMutationObserver.disconnect();
    }
  },
  mounted: function mounted() {
    this.__selectOptionsWrapEl = this.$el.querySelector('.stf-select__options-wraped');
    this.__selectOptionsEl = this.$el.querySelector('.stf-select__options');
    document.body.appendChild(this.__selectOptionsWrapEl);
    this.__selectContainerEl = this.$el.querySelector('.stf-select__container');

    this._addwidowResizeListener();
    this._addOutClickListener();
    this._initOnChangeDetection();
    this._addwidowScrollListener();

    this._isMob = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["b" /* isMob */])();
    this._inputEl = this.$el.querySelector('input');
  },

  methods: {
    keyDown: function keyDown(event) {
      var _this2 = this;

      switch (event.keyCode) {
        case 40:
          this._keyArrowDown(event);
          break;
        case 38:
          this._keyArrowUp(event);
          break;
        case 27:
          this._close();
          var searchInpitEl = this.$el.querySelector('.stf-select__search-input');
          searchInpitEl && searchInpitEl.focus();
          break;
        case 13:
          if (!this.isOpened) {
            this._open();
          } else if (!this.value) {
            var option = document.querySelector('.stf-select__options-wraped[select-id="' + this.idSelect + '"] .stf-select-option');
            if (option) {
              option.click();
            }
          } else {
            this._close();
          }

          break;
        case 9:
          setTimeout(function () {
            return _this2._close();
          }, 100);

          break;
        default:
          {
            if (this._inputEl && this._inputEl !== document.activeElement) {}
          }
      }
    },
    keyPress: function keyPress(event) {
      var _this3 = this;

      if (event.keyCode !== 40 && event.keyCode !== 38 && event.keyCode !== 27 && event.keyCode !== 13 && event.keyCode !== 9 && this._inputEl && this._inputEl !== document.activeElement) {
        this.isOpened = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["c" /* addClass */])(this.$el, 'stf-select_opened');

        this.hasAncesroFixed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["d" /* hasPositioFixedAncestor */])(this.$el);
        __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$emit('stf-select-option.opened', {
          selectId: this.idSelect
        });

        setTimeout(function () {
          _this3._inputEl && _this3._inputEl.focus();
        }, 100);

        this._calculatePositionAnsSize();

        event = event || window.event;
        var charCode = event.which || event.keyCode;
        var charTyped = String.fromCharCode(charCode);
        if (/[\wА-Яа-яїєЇЄь]/.test(charTyped)) {
          this._inputEl.value = charTyped;
        } else {
          this._inputEl.value = '';
        }

        var eventntInput = new Event('input');
        this._inputEl.dispatchEvent(eventntInput);

        __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$emit('stf-select.opened', { idSelect: this.idSelect });
      }
    },
    onUnblur: function onUnblur() {},
    onMouseWheal: function onMouseWheal(event) {
      if (this.__selectOptionsEl.scrollTop >= this.__selectOptionsEl.scrollHeight - this.__selectOptionsEl.offsetHeight && event.deltaY > 0 || this.__selectOptionsEl.scrollTop === 0 && event.deltaY < 0) {
        event.preventDefault();
      }

      this.loadMore();
    },
    onSelectFocus: function onSelectFocus(event) {
      if (this.needFocusInpOnTab && !this._beforeSetValueFocus) {
        this._open();
      }
    },
    open: function open(event) {
      this._open();
      event.preventDefault();
      event.stopPropagation();
    },
    openClose: function openClose() {
      this.isOpened = !this.isOpened;
      if (this.isOpened) {
        this._open();
      } else {
        this._close();
      }
    },


    loadMore: __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default()(loadMore, 100),

    _calculatePositionAnsSize: function _calculatePositionAnsSize() {
      if (!this.isOpened) {
        return;
      }

      var optionsHeight = this.__selectOptionsEl && this.__selectOptionsEl.getBoundingClientRect && this.__selectOptionsEl.getBoundingClientRect().height || 0;
      var containerOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["e" /* getOffset */])(this.__selectContainerEl);

      if ((window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) + window.pageYOffset > containerOffset.top + this.__selectContainerEl.clientHeight + optionsHeight) {
        this.hasAncesroFixed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["d" /* hasPositioFixedAncestor */])(this.$el);
        this.__selectOptionsEl.style.position = this.hasAncesroFixed ? 'fixed' : 'absolute';
        this.__selectOptionsEl.style.top = containerOffset.top + this.__selectContainerEl.offsetHeight - (this.hasAncesroFixed ? window.pageYOffset : 0) + 'px';
        this.__selectOptionsEl.style.left = containerOffset.left - (this.hasAncesroFixed ? window.pageXOffset : 0) + 'px';
        this.__selectOptionsEl.style.width = this.__selectContainerEl.offsetWidth + 'px';
      } else {
        this.hasAncesroFixed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["d" /* hasPositioFixedAncestor */])(this.$el);
        this.__selectOptionsEl.style.position = this.hasAncesroFixed ? 'fixed' : 'absolute';
        this.__selectOptionsEl.style.top = containerOffset.top - this.__selectContainerEl.clientHeight - 1 - (this.hasAncesroFixed ? window.pageYOffset : 0) - optionsHeight + this.__selectContainerEl.offsetHeight + 'px';
        this.__selectOptionsEl.style.left = containerOffset.left - (this.hasAncesroFixed ? window.pageXOffset : 0) + 'px';
        this.__selectOptionsEl.style.width = this.__selectContainerEl.offsetWidth + 'px';
      }
    },
    _addwidowResizeListener: function _addwidowResizeListener() {
      var vm = this;
      this._runOnResize = function (evt) {
        if (!vm._isMob) {
          vm._close();
        }
      };

      window.addEventListener('resize', this._runOnResize);
    },
    _addwidowScrollListener: function _addwidowScrollListener() {
      var vm = this;
      this._runOnScroll = __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default()(function (evt) {
        vm._calculatePositionAnsSize();
      }, 100);

      window.addEventListener('scroll', this._runOnScroll, true);
    },
    _addOutClickListener: function _addOutClickListener() {
      var vm = this;
      this._runOnWindowClick = function (evt) {
        vm._close();
      };

      window.addEventListener('click', this._runOnWindowClick);
    },
    _initOnChangeDetection: function _initOnChangeDetection() {
      var _this4 = this;

      if (!MutationObserver) {
        return;
      }

      this._optionsMutationObserver = new MutationObserver(__WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default()(function () {
        _this4._calculatePositionAnsSize();
      }, 100));

      var config = { subtree: true, childList: true };
      this._optionsMutationObserver.observe(this.__selectOptionsEl, config);
    },
    _open: function _open() {
      this.isOpened = true;
      __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$emit('stf-select-option.opened', {
        selectId: this.idSelect
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_lib__["c" /* addClass */])(this.$el, 'stf-select_opened');
      var inputEl = this.$el.querySelector('input');
      if (inputEl !== document.activeElement) {
        if (inputEl) {
          inputEl.focus();
          inputEl.select();
        } else {
          var searchInpitEl = this.$el.querySelector('.stf-select__search-input');
          if (searchInpitEl && searchInpitEl !== document.activeElement) {
            searchInpitEl.focus();
          }
        }
      }

      this._calculatePositionAnsSize();
      this._inputEl = this.$el.querySelector('input');
      __WEBPACK_IMPORTED_MODULE_1__even_hub_js__["a" /* eventHub */].$emit('stf-select.opened', { idSelect: this.idSelect });
    },
    _close: function _close() {
      this.isOpened = false;
      this._inputEl = this.$el.querySelector('input');
    },
    _keyArrowDown: function _keyArrowDown(event) {
      var elements = this._getArrayElementForFocus();
      var currentFocusedIndex = this._getCurentFocuseIndex(elements);
      var next = currentFocusedIndex === undefined ? 0 : currentFocusedIndex + 1;

      if (next >= (elements && elements.length)) {
        next = 0;
      }

      setTimeout(function () {
        return elements[next] && elements[next].focus();
      }, 100);

      event.stopPropagation();
      event.preventDefault();
    },
    _keyArrowUp: function _keyArrowUp(event) {
      var elements = this._getArrayElementForFocus();
      var currentFocusedIndex = this._getCurentFocuseIndex(elements);
      var prev = currentFocusedIndex === undefined ? -1 : currentFocusedIndex - 1;

      if (prev < 0) {
        if (elements.length) prev = elements.length - 1;
      }

      setTimeout(function () {
        return elements[prev] && elements[prev].focus();
      }, 100);

      event.stopPropagation();
      event.preventDefault();
    },
    _getArrayElementForFocus: function _getArrayElementForFocus() {
      var elements = [];
      elements.push.apply(elements, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$el.querySelectorAll('input')));
      elements.push.apply(elements, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(document.querySelectorAll('[select-id="' + this.idSelect + '"] .stf-select-option')));

      return elements;
    },
    _getCurentFocuseIndex: function _getCurentFocuseIndex(elements) {
      for (var key in elements) {
        if (elements[key] === document.activeElement) {
          return +key;
        }
      }

      return undefined;
    }
  },

  props: {
    value: [Object, Number, String, Array, Boolean],
    more: Boolean,
    pending: Boolean,
    optionsWrapClass: String,
    needFocusInpOnTab: {
      type: Boolean,
      default: false
    }
  }
});

function loadMore() {
  if (!this.pending && this.more && this.__selectOptionsEl.scrollTop > (this.__selectOptionsEl.scrollHeight - this.__selectOptionsEl.offsetHeight) * 0.66) {
    this.$emit('loadMore', {});
  }
}

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__even_hub_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_lib__ = __webpack_require__(31);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'stf-select-option',

    data: function data() {
        return {
            selectId: "",
            isSelected: false
        };
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__even_hub_js__["a" /* eventHub */].$emit("stf-select-option.destroyed", {
            option: this,
            selectId: this.selectId
        });
    },


    methods: {
        selectValue: function selectValue() {
            __WEBPACK_IMPORTED_MODULE_0__even_hub_js__["a" /* eventHub */].$emit("stf-select-option.selected", {
                value: this.value,
                selectId: this.selectId
            });
            this.isSelected = true;
        },
        keyDown: function keyDown(event) {
            switch (event.keyCode) {
                case 13:
                    this.selectValue();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
            }
        }
    },

    mounted: function mounted() {
        var el = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_lib__["a" /* findAncestor */])(this.$el, '.stf-select__options-wraped');

        if (el) {
            this.selectId = el.getAttribute("select-id");
        }

        __WEBPACK_IMPORTED_MODULE_0__even_hub_js__["a" /* eventHub */].$emit("stf-select-option.mounted", {
            option: this,
            selectId: this.selectId
        });
    },


    props: ['value']
});

/***/ })

},[52]);


// WEBPACK FOOTER //
// docs/js/stf-vue-select.c901a0bb7b924d48faed.js